import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const DangerIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.3062 0L15.9947 4.68102L16 11.3062L11.319 15.9947L4.69375 16L0.00527444 11.319L0 4.69375L4.68102 0.00527473L11.3062 0ZM9 12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55229 11 9 11.4477 9 12ZM8 3C7.44772 3 7 3.44772 7 4V8.5C7 9.05228 7.44772 9.5 8 9.5C8.55229 9.5 9 9.05229 9 8.5V4C9 3.44772 8.55229 3 8 3Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

DangerIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default DangerIcon;
